const _ = require('underscore');

class AssetTable {
  static initClass() {
    this.prototype.tableRow = _.template(`\
<tr> \
<td class='td--address'><%- id %></td> \
<td class='td--address'><%- address %></td> \
<td class='td--status'><%- status %></td> \
<td class='td--updated-at'><%- updated_at %></td> \
</tr>`);
  }
  constructor($element, external) {
    this.domElement = $element;
    this.assets = [];
    this.external = external;
  }

  addAssets(assets) {
    this.assets = assets;
    return this.drawTable();
  }

  drawTable() {
    const $table = $(`<table class='table--asset-list'> \
<thead><tr> \
<th class='th--address'>ID</th> \
<th class='th--address'>Address</th> \
<th class='th--status'>Status</th> \
<th class='th--updated-at'>Updated At</th> \
</thead></tr></table>`);
    for (let index = 0; index < this.assets.length; index++) {
      var asset = this.assets[index];
      var $row = $(this.tableRow(asset));
      if (!this.external) {
        this.setRowClickEvent($row, asset);
      }
      $table.append($row);
    }

    this.domElement.empty();
    this.domElement.append('<h3>Assets</h3>');
    return this.domElement.append($table);
  }

  setRowClickEvent($row, asset) {
    return $row.click(() => {
      return (window.location = asset.edit_path);
    });
  }
}
AssetTable.initClass();

//-----------  Export  -----------#
module.exports = AssetTable;
